  <template>
  <section id="login-wrapper">
    <div class="logo-box">
      <img src="@/assets/imgs/trax-daisy-logo.png" alt>
    </div>
    <form @submit.prevent>
      <BaseInput
        type="email"
        v-model="email"
        placeholder="Enter email"
        @keyup.enter="authenticate()"
      />
      <BaseInput
        type="password"
        v-model="password"
        placeholder="Enter password"
        @keyup.enter="authenticate()"
      />
      <BaseButton customClass="login-btn-margin" styleType="simple" @click.native="authenticate()" :disabled="disableSubmit">Login</BaseButton>
    </form>
  </section>
</template>

<script>
import Auth from '@/lib/auth/Auth.js'

export default {
  data () {
    return {
      email: '',
      password: '',
      disableSubmit: false
    }
  },
  mounted () {
    // if requesting a logout, log them out
    if (this.$router.currentRoute.path === '/logout') {
      Auth.logout()
      this.$toast('Successfully logged out.')
    } else {
      // if logged in send them to the dashboard
      if (Auth.getClaims) {
        this.$router.push('/')
      }
    }
  },
  methods: {
    authenticate () {
      this.disableSubmit = true
      Auth.login({ email: this.email, password: this.password })
        .then((response) => {
          if (!response.success) {
            this.disableSubmit = false
          } else {
            this.$router.push('/')
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
#login-wrapper {
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: auto;
  width: 400px;
  height: 100%;
  color: white;
  .logo-box {
    padding: 20px 0px 0px 0px;
    width: 400px;
  }
  // .login-btn-margin {
  //   margin: 0px 10px;
  // }
  form {
    padding: 20px;
    div {
      margin: 5px;
    }
  }
}
</style>
